import { render, staticRenderFns } from "./search_life_record.vue?vue&type=template&id=06b66208"
import script from "./search_life_record.vue?vue&type=script&lang=js"
export * from "./search_life_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports